import { useQuery } from "@tanstack/react-query";
import { httpClient } from "@coworker/http-client";
import { CustomLocationsResult } from "../types/customLocationsResultType";
import { TaskType } from "../enums/taskTypes";

async function fetchRecentCustomLocationsBySearch(
  query: string,
  taskType: TaskType
) {
  return await httpClient.tasks.get<CustomLocationsResult>(
    "/v1/locations/custom",
    { params: { query, taskType } }
  );
}

export function useRecentCustomLocationsBySearch(
  query: string,
  taskType: TaskType
) {
  return useQuery({
    enabled: !!query && query.length > 2,
    queryKey: ["customlocations", "query", query],
    queryFn: async () =>
      await fetchRecentCustomLocationsBySearch(query, taskType),
    staleTime: 0,
  });
}
